import {useState,useEffect,useRef} from "react";
import styled from 'styled-components/macro';
import {CSS_MOBILE_BREAKPOINT,CSS_COLOR_TEXT_PRIMARY,CSS_COLOR_BORDERS,CSS_COLOR_EDITOR_BACKGROUND,CSS_PADDING_COMPACT,CSS_SELECTOR_RADIUS} from './constants';
import Recap from './components/Recap';
import RecapPrice from './components/RecapPrice';
import {findOptions,findSelectedValues,findSelectedValuesOverwrites,getLocationHashStrFromData,getDataFromLocationHash,makeBIGSettings,scrollTop,useScroll} from './helpers';
import AbriPackage from './AbriPackage';
import Editor from './components/Editor';
import ControlButtons from './components/ControlButtons';
import MoveInvitation from './components/MoveInvitation';
import Asker from './components/Asker';
import BIGReact from 'big-react';
import { useResizeDetector } from 'react-resize-detector';
import fscreen from 'fscreen';
import big_rotatecursor from './assets/big_rotatecursor_64.svg';





const ConfiguratorStyled = styled.div`

	font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
	line-height: 1;
	font-weight: 400;
	&,*{box-sizing:border-box}

	.grid {
		display: grid;
		column-gap: 1px;
		row-gap: 1px;
		background-color: ${CSS_COLOR_BORDERS};
		color: ${CSS_COLOR_TEXT_PRIMARY};

		grid-template-columns: 5.5fr 4.5fr;
		grid-template-rows: 1fr 100px;
		grid-template-areas:
			"viewer panel"
			"recap panel";


		@media ${CSS_MOBILE_BREAKPOINT}{
			display: block;
		}

	}

`;

const ConfiguratorGridArea = styled.div`
	background-color: #fff;
	grid-area: ${props => props.className || "auto"};

	&.viewer {
		position:relative;
		.price-micro-holder {
			display: none;
			position: absolute;
			top: 0;
			right: 0;

			border-left: 1px solid ${CSS_COLOR_BORDERS};
			border-bottom: 1px solid ${CSS_COLOR_BORDERS};
			padding: ${CSS_PADDING_COMPACT};

			background: rgba(255, 255, 255, 0.8);
			border-bottom-left-radius: ${CSS_SELECTOR_RADIUS};
			box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
			backdrop-filter: blur(3px);
			-webkit-backdrop-filter: blur(3px);

			user-select: none;
			touch-callout: none;
			pointer-events: none;
		}
		.viewer-pack {
			background-color:#fff;
			position:absolute;
			top:0;
			left:0;
			right:0;
			bottom:0;
			overflow:hidden;
			&:-webkit-full-screen {
				height: 100vh;
				width: 100vw;
			}
		}
	}
	&.panel {
		overflow-y:scroll;
		background-color: ${CSS_COLOR_EDITOR_BACKGROUND};
	}
	@media ${CSS_MOBILE_BREAKPOINT}{
		&.viewer {
			height: 40vh;
			position: sticky;
			top: 63px;
			border-bottom: 1px solid ${CSS_COLOR_BORDERS};
			z-index: 10;

			.price-micro-holder {
				display: block;
			}
			&::before {
				content:'';
				height:10px;
				background-image: linear-gradient(-180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 100%);
				position:absolute;
				bottom:-10px;
				left:0;
				right:0;
			}
			.price-micro-holder,&::before{
				opacity: 0;
				transition: opacity 0.5s;
			}
			&.sticked {
				.price-micro-holder,&::before{
					opacity: 1;
				}
			}
			margin-bottom:139px;
		}
		&.recap {
			margin-top:-139px;
			height: 160px;
			border-bottom: 1px solid ${CSS_COLOR_BORDERS};
		}
		&.panel {
			overflow-y: visible;
		}
	}
`;


// Find default and stabilize
let default_selected_values = {
	...findSelectedValues(findOptions(false)),
	...findSelectedValuesOverwrites(),
	...(getDataFromLocationHash()||{})
}
const default_options = findOptions(default_selected_values);
default_selected_values = findSelectedValues(default_options,default_selected_values);

const abri_package = new AbriPackage();
let download_count = 0;
function increaseDownloadCount(){
	download_count++;
}

function Configurator() {


	const [
		options_and_selected_values,
		setOptionsAndSelectedValues
	] = useState({
		options: default_options,
		selected_values: default_selected_values
	});
	const [active_step, setActiveStep] = useState(false);
	const [computed_objects, setComputedObjects] = useState();
	const [mode, setMode] = useState('edit');
	const big_ref = useRef(null);
	const viewer_pack_ref = useRef(null);
	const { width:viewer_width, height:viewer_height } = useResizeDetector({
		targetRef:viewer_pack_ref,
		refreshMode:'debounce',
		refreshRate:big_ref.current?100:1,
		refreshOptions:{
			trailing: true
		}
	});
	const [khtrwm,setKHTRWM] = useState(false);//know_how_to_rotate_with_mouse

	function setSelection(
		id,
		value
	){
		setOptionsAndSelectedValues((options_and_selected_values)=>{

			const new_selected_values = {
				...options_and_selected_values.selected_values,
				[id]: value
			};
			const new_options = findOptions(new_selected_values);

			const new_options_and_selected_values = {
				options: new_options,
				selected_values: findSelectedValues(new_options,new_selected_values)
			}

			return new_options_and_selected_values;
		});
	}

	useEffect(()=>{
		if(options_and_selected_values&&active_step&&viewer_width&&viewer_height){
			const loc = window.location;

			const big_settings = makeBIGSettings({
				...options_and_selected_values.selected_values,
				active_step: active_step,
				renderer_width: Math.floor(viewer_width),
				renderer_height: Math.floor(viewer_height)
			});
			abri_package.autoAddRefs(
				options_and_selected_values.selected_values,
				big_settings.building
			);
			setComputedObjects({
				share_link:loc.protocol+'//'+loc.host+loc.pathname+'#'+getLocationHashStrFromData(options_and_selected_values.selected_values),
				big_settings: big_settings,
				abri_package_infos: abri_package.infos
			});
			
			window.gtag && window.gtag('event','new_configuration',{
				'event_category': 'configurator'
			});

		}
	},[options_and_selected_values,active_step,viewer_width,viewer_height]);

	function toggleAsk(){
		setMode((mode==='edit')?'ask':'edit');
	}

	window.exportRefs = function(){
		//e.preventDefault();
		abri_package.exportCECARefs();
	}

	function rotate(rot){

		scrollTop(true);

		if(
			computed_objects&&
			computed_objects.big_settings&&
			computed_objects.big_settings.camera&&
			computed_objects.big_settings.camera.rotation_x
		){
			setComputedObjects((co)=>({
				...co,
				big_settings: {
					...co.big_settings,
					camera: {
						...co.big_settings.camera,
						rotation_x: computed_objects.big_settings.camera.rotation_x+rot
					}
				}
			}))
		}
	}

	const can_fullscren = fscreen.fullscreenEnabled;
	const is_fullscreen = fscreen.fullscreenElement;
	function toggleFullscreen(){
		const elem = viewer_pack_ref.current;
		if(elem){
			if(!fscreen.fullscreenElement){
				fscreen.requestFullscreen(elem);
			}else{
				fscreen.exitFullscreen();
			}
		}
	}

	function download(){
		window.gtag && window.gtag('event','download',{
			'event_category': 'configurator'
		});
		if(
			big_ref.current&&
			computed_objects&&
			computed_objects.big_settings&&
			computed_objects.big_settings.building
		){
			const images_to_download = [
				{
					name: '1',
					type: 'perspective',
					camera: {
					}
				},
				{
					name: '2',
					type: 'perspective',
					camera: {
						rotation_x: 4,
						rotation_y: -0.5
					}
				},
				{
					name: '3',
					type: 'perspective',
					reverse_arrows: true,
					camera: {
						rotation_x: 4+Math.PI,
						rotation_y: -0.5
					}
				},
				{
					name: 'pignon gauche',
					type: 'ortho',
					camera: {
						rotation_x: Math.PI/2,
						rotation_y: 0
					}
				},
				{
					name: 'pignon droit',
					type: 'ortho',
					camera: {
						rotation_x: Math.PI*1.5,
						rotation_y: 0
					}
				},
				{
					name: 'long pan haut',
					type: 'ortho',
					camera: {
						rotation_x: Math.PI,
						rotation_y: 0
					}
				},
				{
					name: 'long pan bas',
					type: 'ortho',
					camera: {
						rotation_x: 0,
						rotation_y: 0
					}
				},
				{
					name: 'toiture',
					type: 'ortho',
					camera: {
						rotation_x: 0,
						rotation_y: -Math.PI/2
					}
				}
			];

			// const images_to_download = [
			// 	{
			// 		type: 'perspective',
			// 		camera: {
			// 		}
			// 	}
			// ];

			const renderer_max_pixels = 2000000;
			const renderer_ratio1 = 4;
			const renderer_ratio2 = 3;
			let renderer_width = 0;
			let renderer_height = 0;
			while(renderer_width*renderer_height < renderer_max_pixels){
				renderer_width+=renderer_ratio1;
				renderer_height+=renderer_ratio2;
			}

			increaseDownloadCount();
			function downloadImage(){
				if(images_to_download.length){
					const itd = images_to_download.pop();//image_to_download
					const perspective = (itd.type === 'perspective');

					const bstd = JSON.parse(
						JSON.stringify(computed_objects.big_settings)
					);//big_settings_to_download

					bstd.camera = {
						...bstd.camera,
						lens_length: perspective?50:6000,
						...itd.camera
					}
					bstd.renderer = {
						width:renderer_width,
						height:renderer_height,
						color: 0xFFFFFF,//false
						shadow_opacity: perspective?undefined:0
					}
					bstd.building.reverse_arrows = !!itd.reverse_arrows;
					if(!perspective){
						bstd.building.display_arrows = false;
					}

					big_ref.current.download(bstd,{
						filename: 'Abri-Tole-fr '+download_count+' - '+(perspective?'Vue perspective':'Vue cavalière')+(itd.name?(' '+itd.name):''),
						success_callback: downloadImage
					});
				}else{
					window.BIGDisposeDownloadFallback();
				}
			}
			downloadImage();
		}
	}

	const ROTATE_RAD = Math.PI/9;

	const viewer_pack = <div className="viewer-pack" ref={viewer_pack_ref}>
		<BIGReact
			ref={big_ref}
			value={computed_objects?computed_objects.big_settings:{}}
			onChange={(nbs)=>{
				setComputedObjects((co)=>({
					...co,
					big_settings:nbs
				}));
				setKHTRWM(true);
			}}
			cursor_url={big_rotatecursor}
			cursor_size={64}
		/>

		<ControlButtons
			onDownload={download}
			onRotateleft={()=>{
				rotate(ROTATE_RAD);
			}}
			onRotateright={()=>{
				rotate(-ROTATE_RAD);
			}}
			toggleFullscreen={can_fullscren&&toggleFullscreen}
			is_fullscreen={is_fullscreen}
		/>

		<MoveInvitation
			show={!khtrwm}
			delay={(active_step&&
			active_step!=='depth'&&
			active_step!=='height')?1800:20000}
		/>
	</div>;
	// {(active_step&&active_step!=='depth'&&active_step!=='height')?1800:20000}

	const recap_pack = computed_objects?<Recap
		price={computed_objects.abri_package_infos.total_price}
		mode={'ht'}
		delivery={true}
		surface={computed_objects.abri_package_infos.total_surface}
		mass={computed_objects.abri_package_infos.total_mass}
		madeInFrance={true}
	/>:null;

	const sticked = useScroll()>70;

	return (
		<ConfiguratorStyled>
			{false&&computed_objects&&<a href={computed_objects.share_link} target="_blank" rel="noreferrer">Share_link</a>}
			<div className="grid configurator-root-scaled">
				<ConfiguratorGridArea className={'viewer'+(sticked?' sticked':'')}>
					{viewer_pack}
					{computed_objects&&<div className="price-micro-holder">
						<RecapPrice
							price={computed_objects.abri_package_infos.total_price}
							delivery={true}
							mode={'ht'}
							micro={true}
						/>
					</div>}
				</ConfiguratorGridArea>
				<ConfiguratorGridArea className="recap">
					{recap_pack}
				</ConfiguratorGridArea>
				<ConfiguratorGridArea className="panel">
					{(mode==='edit')&&<Editor
						options={options_and_selected_values.options}
						selected_values={options_and_selected_values.selected_values}
						setSelection={setSelection}
						onAsk={toggleAsk}
						onActiveStep={setActiveStep}
						hideAsk={(computed_objects && !computed_objects.abri_package_infos.valid)}
					/>}
					{(mode==='ask')&&<Asker
						selected_values={options_and_selected_values.selected_values}
						computed_objects={computed_objects}
						onEnd={toggleAsk}
					/>}
				</ConfiguratorGridArea>
			</div>
			
		</ConfiguratorStyled>
	);
}

export default Configurator;
